<template>
  <Select
    ref="selectRef"
    data-sb-regression="sb-select"
    :class="$style.select"
    :placeholder="$attrs.placeholder || $t('common.selectOption')"
    :empty-message="$attrs.emptyMessage || $t('sbDropdown.noOptions')"
    :pt="{
      ...get($attrs, 'pt'),
      listContainer: {
        ...get($attrs, 'pt.listContainer', {}),
        style: {
          maxHeight:  `${props.resultsLimit * defaultHeight}px`,
        }
      },
      pcFilter: {
        ...get($attrs, 'pt.pcFilter', {}),
        root: {
          ...get($attrs, 'pt.pcFilter.root', {}),
          'data-sb-automation': 'sb-select-filter-input',
        }
      },
      clearicon: {
        ...get($attrs, 'pt.clearicon', {}),
        'data-sb-automation': 'sb-select-clear-icon',
      },
    }"
    :append-to="appendTo"
    @show="toggleDropdown"
    @hide="toggleDropdown"
  >
    <template #dropdownicon>
      <i :class="['sb-icon-caret-down', iconExpanded && $style.iconExpanded]" />
    </template>
    <template #value="scope">
      <slot
        name="value"
        v-bind="scope"
      />
    </template>
    <template #option="scope">
      <slot
        name="option"
        :option="scope.option"
      />
    </template>
    <template #empty="scope">
      <slot
        name="empty"
        v-bind="scope"
      />
    </template>
    <template #emptyfilter="scope">
      <slot
        name="emptyfilter"
        v-bind="scope"
      />
    </template>
  </Select>
</template>

<script setup>
import { ref, defineProps, defineOptions, defineExpose, nextTick, useAttrs } from 'vue';
import { useShadowDom } from '@src/mixins/useShadowDom';
import Select from 'primevue/select';
import { defaultHeight } from '@src/themes/shipbob/index';
import get from 'lodash/get';

const attrs = useAttrs();
const selectRef = ref(null);

defineOptions({
  name: 'SbSelect',
});

const props = defineProps({
  /**
   * Number of options to be displayed on expanding options panel
   */
  resultsLimit: {
    type: Number,
    default: 5,
  },
});

const iconExpanded = ref(false);

const show = () => {
  if (iconExpanded.value) return;
  nextTick(() => {
    selectRef.value?.show();
  });
};
defineExpose({
  show,
});
const toggleDropdown = () => {
  iconExpanded.value = !iconExpanded.value;
};

// Append to body when filter=true to ensure shadow DOM compatibility
const isFilterActive = attrs.filter !== undefined && attrs.filter !== false;
const appendTo = isFilterActive ? 'body' : useShadowDom();
</script>

<style lang="scss" module>
@import '@src/components/Select/style/sb-select.module.scss';
</style>
